import * as yup from 'yup';

export const FACE_RECOGNITION_SCHEMA = yup.object({
  nationalCardSerial: yup
    .string()
    .required('سریال پشت کارت ملی الزامی است')
    .matches(/^[a-zA-Z0-9۰-۹٠-٩]+$/, 'فرمت سریال صحیح نیست')
});
